import React, { FC } from 'react';
import { twMerge } from 'tailwind-merge';
import SeatsPreview from '@/components/SeatsPreview/SeatsPreview';
import { ReactComponent as InfoIcon } from '@/assets/icons/info-icon.svg';

interface TableStatusProps {
  playerCount: number;
  activePlayerCount?: number;
  maxPlayers: number;
  tableName?: string;
  tableGame?: string;
  padding?: boolean;
  variantsCount?: number;
  onClick?: (() => void) | undefined;
  onInfoIconClick?: (e: React.MouseEvent) => void;
}
const TableStatus: FC<TableStatusProps> = ({
  playerCount,
  activePlayerCount,
  maxPlayers,
  tableName,
  tableGame,
  padding = true,
  variantsCount = 0,
  onClick,
  onInfoIconClick,
}) => {
  return (
    <div className={twMerge('flex items-center gap-2 md:gap-3', padding && 'px-5 py-3')} onClick={onClick}>
      <SeatsPreview occupiedSeats={playerCount} maxPlayers={maxPlayers} activeSeats={activePlayerCount} />
      <div className="max-w-[5em] xl:max-w-[9em]">
        <p className="block truncate whitespace-nowrap text-sm font-bold text-ph-gray-white">{tableName}</p>
        <div className="flex gap-1">
          <p className="block truncate whitespace-nowrap text-sm text-xs font-bold text-white text-opacity-50">
            {tableGame}
          </p>

          {variantsCount > 1 && (
            <InfoIcon
              className="h-4 w-4 text-ph-white-50"
              onClick={(e) => {
                e.stopPropagation();
                onInfoIconClick?.(e);
              }}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default TableStatus;
